<card name="Хлебные крошки">
  <breadcrumbs card content></breadcrumbs>
</card>
